import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { costingTabInfo } from 'features/costing/utils';

import { setActiveTabInfo } from '@store/actions/CostingAction';
import { clearGlobalFilter } from '@store/actions/FilterAction';

const ParentTabsForFashionDesigner = () => {
	const activeTabInfo = useSelector((store) => store.costingStore.activeTabInfo);
	const dispatch = useDispatch();

	const handleTabClick = (tabKey) => {
		dispatch(setActiveTabInfo(costingTabInfo[tabKey]));
		dispatch(clearGlobalFilter());
	};

	return (
		<div>
			<ul>
				<li
					className={`${
						activeTabInfo?.activeTabName === 'COLLECTION_VIEW_PENDING' ? 'active' : ''
					}`}
					onClick={() => handleTabClick('COLLECTION_VIEW_PENDING')}
				>
					Pending
				</li>
				<li
					className={`${
						activeTabInfo?.activeTabName === 'COLLECTION_VIEW_COMPLETED' ? 'active' : ''
					}`}
					onClick={() => handleTabClick('COLLECTION_VIEW_COMPLETED')}
				>
					Completed
				</li>
			</ul>
		</div>
	);
};

export default ParentTabsForFashionDesigner;
